<div>

  @if (('task.view'|HasPerm) || ('task.offer.view'|HasPerm)) {
    <a title="Neuer Vorgang" class="btn btn-default"
      uiSref="a.workflow.new"
      >
      <span class="fa fa-plus"></span>
    </a>
  }

  @if (data?.workflow?.object?.id && (('task.change'|HasPerm) || ('task.offer.change'|HasPerm))) {
    <button type="button" class="btn btn-default"
            [disabled]="(!!data?.customer?.locked)"
            [title]="((!!data?.customer?.locked) ? 'Kunde gesperrt - es kann kein neuer Vorgang erstellt werden' : '')"
      (click)="duplicate()">
      Vorgang duplizieren
    </button>
  }

  @if (data?.workflow?.object?.id && (('task.change'|HasPerm) || ('task.offer.change'|HasPerm))) {
    <button type="button" class="btn btn-default"
      (click)="open('cancel')">
      Stornieren
    </button>
  }

  @if (data?.workflow?.object?.id && (('task.change'|HasPerm) || ('task.offer.change'|HasPerm))) {
    <button type="button" class="btn btn-default"
      (click)="open('delete')">
      Löschen
    </button>
  }

  @if (data?.workflow?.object?.id && (('task.change'|HasPerm) || ('task.offer.change'|HasPerm))) {
    <a uiSref="a.workflow.document.new"
      [uiParams]="{id: data.workflow.object.id}"
      class="btn btn-default"
      >
      Neues Dokument
    </a>
  }

  @if (data?.workflow?.object?.id && ('workflow.status.change'|HasPerm)) {
    <button type="button" class="btn btn-default"
      (click)="open('status')">
      Statusänderung
    </button>
  }

</div>
